import React from "react";
import ReactApexChart from "react-apexcharts";
import { Button, Paper } from "@mui/material";
import { utils, writeFile } from "xlsx";

const CardsReport = ({ data }) => {

  // Prepare data for the chart
  const categories = data ? Object.keys(data) : [];
  const values = data ? Object.values(data) : [];
  const colorPalette = ["#8B4513", "#B87333", "#D2B48C", "#6B4226"];
  const max = Math.max(...values, 0);

  const series = [
    {
      name: "Count",
      data: values,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%', // Adjust the percentage to control bar width
        distributed: true, // Distribute colors to each bar
        borderRadius: 5,
        borderRadiusApplication: 'end',

        dataLabels: {
          position: 'top', // Position data labels at the top of bars
          hideOverflowingLabels: true
        },
      },
    },
    colors: colorPalette,
    dataLabels: {
      enabled: true,
      formatter: (val) => val,
      offsetY: -20,
      style: {
        fontSize: '15px',
        colors: ["#304758"],
      },
    },
    xaxis: {
      categories: categories.map(category => category.replace(/([A-Z])/g, ' $1').trim()), // Format category labels
    },

    yaxis: {
      title: {
        text: 'Count',
      },
      min: 0,
      max: max + Math.ceil(max * 1), // Add 10% padding for better spacing
    },
    title: {
      text: "User Data Overview",
      align: 'center',
    },
  };



  const exportToExcel = () => {

    const ws = utils.json_to_sheet(
      categories.map((category, index) => ({
        Category: category.replace(/([A-Z])/g, ' $1').trim(),
        Value: values[index],
      }))
    );
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "User Data");
    writeFile(wb, "user_data.xlsx");
  };


  return (
    <Paper elevation={3} style={{ padding: "20px", margin: "20px", width: "100%" }}>
      <div style={{ textAlign: "center", padding: "10px" }}>
        <Button
          sx={{
            background: 'linear-gradient(135deg, #ffffff 30%, #f0f0f0 90%)',
            color: '#2f2b3de6',
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
            padding: '0.5rem 1rem',
            fontSize: "15px",
            transition: 'all 0.3s ease',
            marginBottom: '20px',
            '&:hover': {
              background: 'linear-gradient(135deg, #f0f0f0 30%, #e0e0e0 90%)',
              boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
              transform: 'translateY(-2px)',
            },
          }}
          onClick={exportToExcel}
          disabled={!series || series[0].data.length === 0}
        >
          Export to Excel
        </Button>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          overflowX: 'auto' // Adds horizontal scrolling if needed
        }}>
          {
            (!series || series[0].data.length === 0) ? <div>Please Select Your Camapigns</div> : <ReactApexChart options={options} series={series} type="bar" height={400} width={700} />
          }
        </div>
      </div>
    </Paper>
  );
};

export default CardsReport;
